export class StructureId {
    /** @type {string} */
    id;
    /** @type {string} */
    regio;
    /** @type {string} */
    stereo;
    /** @type {string} */
    protonation;
    /** @type {string} */
    parent;

    constructor(id, regio, stereo, protonation, parent) {
        this.id = id;
        this.regio = regio;
        this.stereo = stereo;
        this.protonation = protonation;
        this.parent = parent
    }

    get imgRef() {
        return '/api/structure/' + this.id + '.svg';
    }

    static parseServerJsonList(json) {
        const result = [];
        for (const e of json) {
            // If we get an error in one of the json, we simply skip such json and don't show error
            if (!e.error)
                result.push(this.parseServerJson(e));
        }
        return result;
    }

    static parseServerJson(json) {
        return new StructureId(json.id, json.regio, json.stereo, json.protonation, json.parent);
    }
}